import { Badge, Space } from "antd";
import {
  CheckCircleOutlined,
  LoadingOutlined,
  RightOutlined,
} from "@ant-design/icons";
import "./RecruitmentQuestionMembershipCard.scss";
import { useEffect, useState } from "react";
import httpclient from "../../../service/httpclient";
import useWindowWidth from "../../../hooks/useWindowWidth";

function Description() {
  return (
    <div className="recruitment-question-membership-card-description">
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          解锁所有提单
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          会员模拟考试
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          秋招新题速达
        </Space>
      </div>
      <div>
        <Space>
          <CheckCircleOutlined style={{ color: "rgb(103, 117, 245)" }} />
          更多福利...
        </Space>
      </div>
    </div>
  );
}

function RecruitmentQuestionMembershipCard() {
  const [productMembership, setProductMembership] = useState(null);
  useEffect(() => {
    httpclient.getOneProductMembership(1).then((res) => {
      setProductMembership(res);
    }, []);
  }, []);

  const { windowWidth } = useWindowWidth();

  return (
    <div className="recruitment-question-membership-card">
      <div className="recruitment-question-membership-card-title">
        <b style={{ fontSize: 18, flexShrink: 0 }}>
          题库Pro会员
          {windowWidth < 899 && (
            <span
              style={{
                border: "2px solid white",
                padding: "2px 6px",
                borderRadius: 40,
                fontSize: 14,
                fontWeight: "normal",
                marginLeft: "10px",
              }}
            >
              早鸟价
            </span>
          )}
        </b>
        {productMembership ? (
          <Space style={{ flexShrink: 0 }} align="baseline">
            <span>
              <b style={{ fontSize: 20 }}>
                ¥{productMembership.calculated_price / 100}
              </b>
            </span>
            <span>
              <del>¥{productMembership.price / 100}</del>/年
            </span>
          </Space>
        ) : (
          <LoadingOutlined />
        )}
      </div>

      {windowWidth >= 899 ? (
        <Badge.Ribbon children={<Description />} text="早鸟价" />
      ) : (
        <Description />
      )}

      <div
        className="recruitment-question-membership-card-button"
        type="primary"
        onClick={() =>
          window.open(
            "/info/product_membership/1",
            "_blank",
            "noopener,noreferrer"
          )
        }
      >
        <b style={{ fontSize: 16 }}>
          <Space>
            前往了解
            <RightOutlined />
          </Space>
        </b>
      </div>
    </div>
  );
}

export default RecruitmentQuestionMembershipCard;
